/**
 * Shared constants for the "אינדיקציה לביצוע הפעולה תחת הרדמה" feature
 * (כללית מושלם, anesthesia surgery codes, patient aged 18+).
 */

// Client launch: ship BMI + OSA + age only. Flip to true to restore option 3
// ("מצב בריאותי המחייב הרדמה") + auto pre-surgery + its diagnosis code.
export const ENABLE_MEDICAL_CONDITION_INDICATION = false;

// Leading code of the diagnosis options returned by the typehead.
// BMI and the medical condition are ICD-9 categories, so the actual options
// carry a sub-code (V85.41, V71.89, ...) and must be matched by prefix.
export const ANESTHESIA_DIAGNOSIS_CODE_PREFIXES = {
  BMI: "27801",
  OSA: "32723",
  MEDICAL_CONDITION: "V718"
};

// The fund only covers BMI of 40 and above, which is the ICD-9 V85.4x family.
// Written both with and without the dot since the list is not consistent.
export const BMI_40_PLUS_CODE_PATTERN = /^V85\.?4/i;

// Value of the "הרדמה" select meaning "נוכחות מרדים של בית החולים"
export const HOSPITAL_ANESTHETIST_VALUE = "מרדים פנימי";
